var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-avatar",class:{
    'b2b-avatar--flat': this.flat,
  },style:({
    width: _vm.$_size,
    height: _vm.$_size,
  }),on:{"click":_vm.$_onClick}},[(!_vm.src)?_c('user-icon',{attrs:{"size":String(_vm.size / 2)}}):_c('b2b-image',{staticClass:"b2b-avatar__img",attrs:{"src":_vm.src,"cover":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }